(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = Number($(this).attr('dataprice'));
      var compareprice = Number($(this).attr('datacompare'));
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
      // yy: mantém o botão "Comprar" do card sincronizado com a cor clicada, pra não correr o
      // risco de adicionar a cor errada quando o card já tem um botão de compra direta (cards
      // divididos por cor). Se a cor clicada estiver esgotada, troca pro link da página do
      // produto (onde o "avise-me quando chegar" funciona de verdade) em vez de só desabilitar.
      var variantId = $(this).attr('datavariantid');
      if (variantId) {
        var $wrap = $(this).parents('.single-product-wrap');
        var $cartAction = $wrap.find('cart-action');
        var $soldout = $wrap.find('.yy-split-soldout');
        if ($cartAction.length && $soldout.length) {
          var available = stocks === 'true';
          if (available) {
            $wrap.find('cart-action form [name="id"]').val(variantId);
            $cartAction.removeAttr('hidden');
            $soldout.attr('hidden', 'hidden');
          } else {
            $cartAction.attr('hidden', 'hidden');
            $soldout.removeAttr('hidden');
            var base = $soldout.attr('data-yy-base-url');
            $soldout.find('a').attr('href', base + '?variant=' + variantId);
          }
        }
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });

    // yy: quando a última fileira da grade de coleção/busca fica incompleta (comum agora que
    // cada produto pode virar vários cards, um por cor), faz só os cards que sobraram esticarem
    // pra preencher a fileira, em vez de deixar espaço vazio. Roda de novo ao redimensionar,
    // porque o número de colunas muda por largura de tela (4 no desktop, 3 no tablet, 2 no celular).
    function yyFillLastRow() {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      var items = Array.prototype.slice.call(grid.children).filter(function (el) {
        return el.tagName === 'LI';
      });
      items.forEach(function (li) { li.style.gridColumn = ''; });
      if (!items.length) return;
      var colCount = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      if (!colCount) return;
      var remainder = items.length % colCount;
      if (remainder === 0) return;
      var lastRow = items.slice(items.length - remainder);
      var base = Math.floor(colCount / remainder);
      var extra = colCount - base * remainder;
      lastRow.forEach(function (li, i) {
        var span = base + (i < extra ? 1 : 0);
        li.style.gridColumn = 'span ' + span;
      });
    }
    yyFillLastRow();
    var yyFillLastRowTimer;
    window.addEventListener('resize', function () {
      clearTimeout(yyFillLastRowTimer);
      yyFillLastRowTimer = setTimeout(yyFillLastRow, 150);
    });
  });
})(jQuery);
